import AuthManager from '~/modules/auth/AuthManager.js'

export default ({ app, store }, inject) => {
  inject('authManager', new AuthManager(app, store))
}
